import React, { Fragment, useContext } from "react";
import _ from "lodash";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import PlayerAccordion from "games/PlayerAccordion";
import FootballFields from "./FootballFields";
import { convertNum } from "util/misc";
import { midStatsChanges } from "games/model/midStats";

const PlayerList = ({ side, activePlayers, setActivePlayers }) => {
  const {
    usePlayByPlay: [state, dispatch]
  } = useContext(PlayByPlayContext);
  const { game } = state;
  const schoolName = _.get(game, [side, "season", "team", "school", "name"]);

  const handleInputChange = (event, name, id) => {
    if (!name) return;
    const value = event.target.value;
    const transformedPlayers = activePlayers.map((player) => {
      if (player.id !== id) return player;
      const transformedPlayer = {
        ...player,
        [name]: convertNum(value)
      };
      return {
        ...transformedPlayer,
        ...midStatsChanges(name, transformedPlayer)
      };
    });
    setActivePlayers(transformedPlayers);
  };

  // dispatch on input blur instead of on input change to help with performance --
  // since blur happens less often
  const handleInputBlur = () => {
    dispatch({
      type: "editPlayerStats",
      payload: {
        side,
        playerStats: activePlayers
      }
    });
  };

  const getPlayerFields = (i) => {
    const activeEntity = _.get(activePlayers, i);
    return (
      <FootballFields
        handleInputChange={handleInputChange}
        handleInputBlur={handleInputBlur}
        activeEntity={activeEntity}
        id={activeEntity.id}
      />
    );
  };

  return (
    <Fragment>
      <h4>Edit Player Stats for {schoolName}</h4>
      <PlayerAccordion
        players={activePlayers}
        getPlayerFields={getPlayerFields}
        namePath="name"
      />
    </Fragment>
  );
};

export default PlayerList;
